
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import Panoramic from '@/components/Panoramic.vue'
import Guide from '@/components/Guide.vue'
import Slide from '@/components/NewSlide.vue'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    components: {
        Panoramic,
        Guide,
        Slide
    },
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common
        const $router = useRouter()
        const panoramic = ref<any>(null)
        const isLoaded = ref<boolean>(false)
        const isWeiXin = ref<boolean>(false)
        const popShow = ref<boolean>(false)

        const back = () => {
            $router.replace('/')
        }

        const goDB = () => {
            if (COVERAPP.Attribute.isMb()) {
                popShow.value = true
            } else {
                window.open('https://www.mssswhyjy.com/')
            }
        }

        const gobwg = () => {
            if (COVERAPP.Attribute.isMb()) {
                window.location.href = 'http://www.sscbwg.com/'
            } else {
                window.open('http://www.sscbwg.com/')
            }
        }

        const reset = () => {
            panoramic.value.reset()
        }

        const load = () => {
            COVER.pageLoaded() 
            isLoaded.value = true
        }

        const getSize = () => {
            const page = document.querySelector('.page-hall') as HTMLDivElement
            page.style.height = window.innerHeight + 'px'
        }

        onBeforeUnmount(() => {
            window.removeEventListener('resize', getSize)
        })

        onMounted(() => {
            isWeiXin.value = COVERAPP.Attribute.isWeixin()
            getSize()
            window.addEventListener('resize', getSize)
            COVER.track('load', '全景页面')
            COVER.onshare($store.state.shareData)
        })    

        return {
            panoramic,
            isLoaded,
            isWeiXin,
            popShow,
            back,
            goDB,
            gobwg,
            reset,
            load
        }
    }
})
